// @flow

import React from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { Flex, Box } from '../../../../grid';
import {
  FormRow,
  ReduxFormDays,
  ReduxFormError,
  ReduxFormMonths,
  ReduxFormYears,
} from '../../../../form';
import {
  getDate,
  getRequired,
} from '../../../../../store/formSettings/selectors';
import { media } from '../../../../../helpers';
import type { Theme } from '../../../../../types';
import {
  dateMultiField,
  requiredMultiField,
} from '../../../../../helpers/formValidators';
import { Text } from '../../../../form/labelText';

type OwnProps = {|
  label: string,
  name: string,
|};

type StateProps = {|
  requiredError: string,
  dateError: string,
|};

type Props = OwnProps & StateProps;

const WrappedFlex = styled<typeof Flex, Theme>(Flex)`
  flex-wrap: wrap;

  ${media.sm(css`
    flex-wrap: nowrap;
  `)}
`;

const DateOfBirth = ({
  requiredError,
  dateError,
  label,
  name,
}: Props) => {
  const dayFieldName = 'day';
  const monthFieldName = 'month';
  const yearFieldName = 'year';
  const multiFields = [yearFieldName, monthFieldName, dayFieldName];

  const requiredValidator = requiredMultiField(requiredError)(multiFields);

  const dateValidator = dateMultiField(dateError)({
    year: yearFieldName,
    month: monthFieldName,
    day: dayFieldName,
  });

  return (
    <FormRow>
      <WrappedFlex
        alignItems="center"
        flexGrow={1}
        flexBasis="100%"
      >
        <Flex width={6 / 12}><Text>{label}</Text></Flex>
        <Flex width={8 / 12} flexDirection="column">
          <Flex width={1}>
            <Box mr="0.5em" width={4 / 12}>
              <Field
                name={`${name}.${dayFieldName}`}
                component={ReduxFormDays}
              />
            </Box>
            <Box ml="0.5em" mr="0.5em" width={4 / 12}>
              <Field
                name={`${name}.${monthFieldName}`}
                component={ReduxFormMonths}
              />
            </Box>
            <Box ml="0.5em" width={4 / 12}>
              <Field
                name={`${name}.${yearFieldName}`}
                component={ReduxFormYears}
              />
            </Box>
          </Flex>
          <Field
            component={ReduxFormError}
            multiFields={multiFields}
            name={name}
            validate={[
              requiredValidator,
              dateValidator,
            ]}
          />
        </Flex>
      </WrappedFlex>
    </FormRow>
  );
};

const mapStateToProps = (state): StateProps => ({
  requiredError: getRequired(state),
  dateError: getDate(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(DateOfBirth);
